import React, { useState } from "react";
import ImageCycler from "./ImageCycler";
import styles from "../src/styles/citiesshowcaser.module.css";

export default function CitiesShowcaser({ citiesArr, imgsArr }) {
    const [currCityNum, setCurrCityNum] = useState(0)

    const cityNames = Object.keys(citiesArr)
    const cityPercents = Object.values(citiesArr)

    return (
        <div className={styles.container}>
            <div className={styles.ledger}>
                {cityNames.map((name, indx) =>
                    <button
                        key={name}
                        className={`${styles.cityrow} ${indx === currCityNum ? styles.active : ""}`}
                        onClick={() => setCurrCityNum(indx)}
                    >
                        <span className={styles.rank}>{String(indx + 1).padStart(2, "0")}</span>
                        <span className={styles.cityname}>{name}</span>
                    </button>
                )}
            </div>

            <ImageCycler
                cityPercentages={cityPercents[currCityNum] ? cityPercents[currCityNum] : ""}
                cityName={cityNames[currCityNum]}
                imgsArr={imgsArr[currCityNum] ? imgsArr[currCityNum] : []}
            />
        </div>
    )
}
